import { IJob } from '../job/Job';
import { IMonitorable } from '../monitoring/IMonitorable';
import { SearchExpression } from '../search/advanced/SearchExpression';

export interface IBatch extends IMonitorable {
  prefix: string;
  delimiter: string;
  startValue: number;
  zeroPaddingLength: number;
  filesPerBatch: number;
  keepFamiliesTogether: boolean;
  job: IJob;
  id: string;
  projectId: string;
  collections: string[];
}

export class Batch implements IBatch {
  public prefix: string;
  public delimiter: string;
  public startValue: number;
  public zeroPaddingLength: number;
  public filesPerBatch: number;
  public keepFamiliesTogether = false;
  public job: IJob;
  public id: string;
  public projectId: string;
  public collections: string[];
  public filter;
  public searchExpression: SearchExpression;
  public columnFilters: SearchExpression;
  public query: String;
  public users: Array<String>;
  public roles: Array<String>;
  public resources: Array<string>;

  constructor(id: string = "", users: Array<String> = [], roles: Array<String> = []) {
    this.delimiter = "_";
    this.startValue = 1;
    this.zeroPaddingLength = 3;
    this.keepFamiliesTogether = true;
    this.filesPerBatch = 200;
    this.id = id;
    this.users = users;
    this.roles = roles;
  }
}
